<template>
    <div class="main-content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-6 mx-auto">
                    <div class="card p-4 shadow-sm border-0">
                        <h4 class="mb-4 text-primary"><i class="fas fa-id-card mr-2"></i> Consulta de Identidad (Registro Civil)</h4>

                        <div class="form-group mb-3">
                            <label>Número de Cédula (10 dígitos):</label>
                            <vs-input
                                v-model="cedula"
                                placeholder="Ej: 092XXXXXXXX"
                                maxlength="10"
                                @keyup.enter="consultarCedula()"
                                block>
                                <template #icon><i class='fas fa-search'></i></template>
                            </vs-input>
                        </div>

                        <vs-button @click="consultarCedula()" :loading="loading" block class="mb-4">
                            Buscar Ciudadano
                        </vs-button>

                        <div v-if="ciudadano" class="card bg-light border p-3 rounded">
                            <h5 class="text-secondary border-bottom pb-2 mb-3">INFORMACIÓN CIVIL</h5>
                            <div class="mb-2">
                                <small class="text-muted d-block">Nombres y Apellidos Completos:</small>
                                <strong style="font-size: 16px;" class="text-dark">{{ ciudadano.nombre_completo }}</strong>
                            </div>
                            <div class="mt-3">
                                <small class="text-muted d-block">Estado de Validación:</small>
                                <span class="badge badge-success p-1">{{ ciudadano.condicion }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { alertasM } from '../../../util.js';

export default {
    mixins: [alertasM],
    data() {
        return {
            cedula: '',
            loading: false,
            ciudadano: null
        }
    },
    methods: {
        consultarCedula() {
            if (this.cedula.length !== 10) {
                this.notify("La cédula debe tener exactamente 10 dígitos", "", "top", "center", "fas fa-exclamation-triangle", "warning");
                return;
            }

            this.loading = true;
            this.ciudadano = null;

            axios.get('/cedula/consultar', { params: { cedula: this.cedula } })
                .then(res => {
                    if (res.data.success) {
                        this.ciudadano = res.data.data;
                    }
                })
                .catch(err => {
                    let msg = "Error al conectar con la consulta civil.";
                    if (err.response && err.response.data) {
                        msg = err.response.data.message;
                    }
                    this.notify(msg, "", "top", "center", "fas fa-times", "danger");
                })
                .finally(() => { this.loading = false; });
        }
    }
}
</script>
